import React from 'react';
import { useSearchParams } from 'react-router-dom';
import IELTSCourse from '../courses/IELTSCourse';
import { vocabularyWritingData, getDataForDifficulty } from '../courses/data/vocabulary/vocabularyWriting';

export default function VocabularyForWriting() {
  const [searchParams] = useSearchParams();
  const lessonId = searchParams.get('lessonId');
  const difficulty = parseInt(searchParams.get('difficulty')) || 3;

  return (
    <IELTSCourse
      {...(difficulty !== 3 ? getDataForDifficulty(difficulty) : vocabularyWritingData)}
      lessonId={lessonId}
      difficulty={difficulty}
    />
  );
}
